module.exports = __webpack_public_path__ + "static/media/shubham_gandhi.b4f5a2de.png";